
import {initWebComponent} from "@/helpers/web-component-helper";
import {hideAllInfo, hideLayerInfoForm} from "@/helpers/layer/info/layer-info-helper";
import {removeGeoLocation, setGeoLocation, setGeoLocationInterval} from "@/helpers/ol/ol-geolocation-helper";
import {hideElementsBySelector, removeClassBySelector, showElementsBySelector} from "@/helpers/element-helper";

export class BookmarkGeoLocationComponent extends HTMLElement {
    constructor(){
        super();

        let  innerHTML = `
            <div class="card m-3 bg-lighter" style="border-radius: 10px;">
                 <div class="card-header font-weight-bold p-2">
                     <span class="fa fa-map-marker navbar-icon" style="font-size:15px"></span>
                     Gebruik GPS locatie
                     <button class="ml-1 btn icon-btn btn-sm btn-outline-secondary float-right btnHideInfoMenu">
                        <span class="fa fa-times"></span>
                     </button>
                 </div>
                 <div class="card-body p-2">
                    <div class="mb-2">
                        <label class="switcher mr-1">
                         <input type="checkbox" class="switcher-input">
                            <span class="switcher-indicator">
                              <span class="switcher-yes">
                                <span class="fa fa-draw-polygon"></span>
                              </span>
                              <span class="switcher-no">
                                <span class="fa fa-times"></span>
                              </span>
                            </span>
                            <span class="switcher-label">Activeer GPS</span>
                          </label>
                    </div>
                    <div class="d-none" id="divGeoLocationInterval">
                        <p class="mb-0 mt-1">Hoe vaak moet de kaart zich centreren op de GPS locatie:</p>
                         <div class="list-group mt-1">
                          <a href="javascript:void(0)" data-seconds="" class="list-group-item list-group-item-action active">Niet centreren</a>
                          <a href="javascript:void(0)" data-seconds="2000" class="list-group-item list-group-item-action">Elke 2 seconden</a>
                          <a href="javascript:void(0)" data-seconds="10000" class="list-group-item list-group-item-action">Elke 10 seconden</a>
                          <a href="javascript:void(0)" data-seconds="30000" class="list-group-item list-group-item-action">Elke 30 seconden</a>
                          <a href="javascript:void(0)" data-seconds="60000"  class="list-group-item list-group-item-action">Elke 60 seconden</a>
                        </div>
                  </div>
                 </div>
             </div>
                `

        const template = document.createElement('template');
        template.innerHTML = innerHTML;
        initWebComponent(this, template)

        this.addEventListener('click', (event) => {

            if(event.target.type === 'checkbox') {
                if(event.target.checked) {
                    setGeoLocation(window.map)
                    showElementsBySelector('#divGeoLocationInterval')
                    document.querySelector('ol-track-location').querySelector('button').classList.add('active')
                } else {
                    removeGeoLocation()
                    hideElementsBySelector('#divGeoLocationInterval')
                    document.querySelector('ol-track-location').querySelector('button').classList.remove('active')
                }
            }
            if(event.target.tagName === 'A') {
                removeClassBySelector('.list-group-item-action', 'active')
                event.target.classList.add('active')
                setGeoLocationInterval(event.target.dataset.seconds)
            }
        })
    }
}

